import { createTheme } from '@mui/material';
import './styles/fonts.scss';

const FONT = {
  styleOverrides: {
    root: {
      fontFamily: 'Rubik',
    },
  },
};
const materialTheme = createTheme({
  typography: {
    fontFamily: ['Rubik'],
  },
  components: {
    MuiButton: {
      ...FONT,
      defaultProps: {
        focusRipple: false,
      },
    },
    MuiTab: {
      ...FONT,
      defaultProps: {
        focusRipple: false,
      },
    },
    MuiMenuItem: {
      ...FONT,
      defaultProps: {
        focusRipple: false,
      },
    },
    MuiToggleButton: {
      defaultProps: {
        focusRipple: false,
      },
    },
    MuiCard: {
      FONT,
    },
  },
});

export default materialTheme;
